import { POST } from '../consts/Methods'
import apiCall from './ApiCall'

export const events = {
  open_offer: 'dealer_open_offer',
  create_bet: 'dealer_create_bet',
}

const track = (eventName, eventData, eventTags = []) => {
  const eventTagsWithAdminEmail = [...eventTags, { dealer_email: localStorage.getItem('dealer_email'), }]
  const requestParams = {
    event_name: eventName,
    event_tags: eventTagsWithAdminEmail,
    event_data: eventData,
  }
  apiCall({ endpoint: '/analytics/create', params: requestParams, method: POST, }).catch(null)
}

export default track

